// eslint-disable-next-line import/prefer-default-export
export const UserPath = {
  User: '/user',
  Users: '/users',
  Profile: '/profile',
  Account: '/account',
  Subscriptions: '/subscriptions',
};
